<template>
  <div class="wgtSettings" :class="{ 'isTableShown': isShowTable }">
    <div class="cardR">
      <div class="boxR">
        <div class="myZoomClass" :class="$store.state.TClrs" id="agingtrendsnap">
          <div class="content-panel1" v-show="IsAgeErr">
            <h2 class="chartTitle hide-on-presentation themeclr2">Aging Trend</h2>
            <apiErrorComponent @tryReload="tryReload" compTitle="Aging Trend" compId="agingtrendsnap">
            </apiErrorComponent>
          </div>
          <div class="content-panel1" v-show="!IsAgeErr">
            <div class="insideL  hide-on-presentation " :class="isHovered ? 'showL' : ''">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-bars" />
              </div>
              <div class="contents">
                <span v-show="!IsAgeErr">
                  <font-awesome-icon icon="fa-solid fa-diagram-successor" title="Switch to Alternate View"
                    v-on:click="swapCharts()" />
                  <font-awesome-icon icon="fa-solid fa-table" v-on:click="showTable()" title="Show Table" />
                  <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" v-on:click="addToSlider()"
                    title="Add to Storyboard" />
                  <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                    v-on:click="downloadDom()" />
                  <font-awesome-icon icon="fa-solid fa-file-export" title="Export Insights" v-on:click="downIns()" />
                </span>
              </div>
            </div>
            <div class="insideR hide-on-presentation">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-info" />
              </div>
              <div class="contents">
                {{ $parent.widgetInfo.Aging }} You can click on individual bars to get more insights.
                <br />
                <br />
                Actions you can take on this widget: <br />
                <ul>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-diagram-successor" /> to
                    swap between bar and line chart view
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-table" /> to see table with values
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" /> to add to storyboard
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to download the chart with
                    current insight
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-export" /> to download all the insights
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="!isLoadAgn">
              <widgetLoadingComp></widgetLoadingComp>
            </div>
            <div class="infoLeftHover" v-show="isHovered" v-on:mouseleave="isHovered = false">
              <div v-for="(value, index) in funcCrt" :key="index" class="cursor-pointer">
                <span v-on:click="explainModel(value)">{{ value.split('~')[1] }}</span>
              </div>
            </div>
            <div v-show="isLoadAgn"></div>
            <h2 class="chartTitle hide-on-presentation themeclr2">Aging Trend</h2>
            <div class="panel-body text-center" :class="{ 'BlurClass': !isLoadAgn }">
              <div class="row">
                <div>
                  <div class="card-quality Inc Inc1">
                    <h5 class="text-center">
                      {{ val1 > 999 ? val1.toLocaleString() : val1 }}
                    </h5>
                    <div class="text-ellipsis myChartNumber"> &lt; 1 day
                    </div>
                    <div class="valrPrec">{{ perc1 }}<small>%</small></div>
                  </div>
                  <div class="card-quality Inc Inc1">
                    <h5 class="text-center">
                      {{ val2 > 999 ? val2.toLocaleString() : val2 }}
                    </h5>
                    <div class="text-ellipsis myChartNumber"> 1 - 5 days
                    </div>
                    <div class="valrPrec">{{ perc2 }}<small>%</small></div>
                  </div>
                  <div class="card-quality Inc Inc1">
                    <h5 class="text-center">
                      {{ val3 > 999 ? val3.toLocaleString() : val3 }}
                    </h5>
                    <div class="text-ellipsis myChartNumber"> 5 - 10 days
                    </div>
                    <div class="valrPrec">{{ perc3 }}<small>%</small></div>
                  </div>
                  <div class="card-quality Inc Inc1">
                    <h5 class="text-center">
                      {{ val4 > 999 ? val4.toLocaleString() : val4 }}
                    </h5>
                    <div class="text-ellipsis myChartNumber"> &gt; 10 days
                    </div>
                    <div class="valrPrec">{{ perc4 }}<small>%</small></div>
                  </div>
                  <div class="chartHeightControlIn" v-show="!IsAgeErr">
                    <div id="agingtrend"></div>
                  </div>
                </div>
              </div>
              <div v-if="isShowTable">
                <div v-on:click="onBtnExport()" class="myfaBtn spl">
                  <font-awesome-icon :icon="['fas', 'fa-download']" />
                </div>
                <ag-grid-vue style="width: 96%;height:470px;"
                  class="table-striped thmHead myMttrTbl v01 ag-theme-alpine myHomeTable" :columnDefs="asgcolsDefs"
                  @grid-ready="onPriorAsg" :modules="modules">
                </ag-grid-vue>
              </div>
              <div v-if="IsInsightAging" class="widgetError text-center">
                <widgetDataMsg></widgetDataMsg>
              </div>
            </div>
            <widgetsSlider :insideArr="aginginsight" :isInsErr="IsAgInsErr" compTitle="Aging Trend"
              compId="agingtrendsnap" :isErr="IsAgeErr"></widgetsSlider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var myChartAge, chartDomAge
function reportWindowSizeAge() {
  if (myChartAge != undefined) {
    chartDomAge.style.width = (document.getElementById('agingtrendsnap').clientWidth - 50) + "px";
    myChartAge.resize()
  }
}
import {
  useRoute
} from 'vue-router';
import * as echarts from 'echarts';
import domtoimage from "dom-to-image-more";
import {
  saveAs
} from 'file-saver';
import {
  AgGridVue
} from "@ag-grid-community/vue3";
import {
  ClientSideRowModelModule
} from "@ag-grid-community/client-side-row-model";
import {
  CsvExportModule
} from "@ag-grid-community/csv-export";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import widgetDataMsg from '../smallcomp/chartDataMsg.vue'
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import screenShotMix from "./../../mixin/screenShotMix";
import apiErrorComponent from '../smallcomp/apierror.vue';
import widgetsSlider from '../smallcomp/widgets-slider.vue';
import widgetExplainData from "./../../mixin/wiExplainLink";
export default {
  name: 'AgingTrend',
  mixins: [screenShotMix, widgetExplainData],
  components: {
    widgetDataMsg,
    widgetLoadingComp,
    AgGridVue,
    apiErrorComponent,
    widgetsSlider
  },
  props: {
    getPins: Object,
    tabname: String,
  },
  data() {
    return {
      modules: [ClientSideRowModelModule, CsvExportModule],
      isLoadAgn: false,
      IsAgeErr: false,
      IsAgeshow: false,
      IsAgInsErr: false,
      isShowTable: false,
      IsInsightAging: false,
      val1: 0,
      val2: 0,
      val3: 0,
      val4: 0,
      perc1: 0,
      perc2: 0,
      perc3: 0,
      perc4: 0,
      aginginsight: [],
      myColorArray: [],
      myBorderArray: [],
      asgLisApi: null,
      asgLis: null,
      asgcolsDefs: [],
      splitlabel: [],
      paginNo: 0,
      paginIdx: "transform: translateX(0%)",
      isChartRedraw: true,
      seriesArr: [],
      isdrawBar: true,
      isHovered: false,
      funcCrt: []
    }
  },
  methods: {
    explainModel(currpass) {
      var emit = this.$emit
      emit("explainModel", currpass)
    },
    genrateExplainLink() {
      this.funcCrt = []
      this.funcCrt = this.widgetExplain(this.aginginsight)
    },
    pagNav(index) {
      this.paginNo = index;
      this.paginIdx = "transform: translateX(-" + 5 * index + "%)"
    },
    tryReload() {
      this.getAginginsights(this.getwgtCond)
    },
    addToSlider() {
      let insArr = this.aginginsight;
      this.isHovered = false
      let name = "Aging Trend - " + this.getPins.viewName;
      let screenShort = {
        id: 'agingtrendsnap',
        name: 'agingtrendsnap.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    onPriorAsg(params) {
      this.asgLisApi = params.api
      this.gridColumnApi = params.columnApi
      this.asgLisApi.setRowData(this.asgLis);
      params.api.sizeColumnsToFit();
    },
    onBtnExport() {
      this.asgLisApi.exportDataAsCsv();
    },
    showTable() {
      if (this.isShowTable) {
        this.isShowTable = false
      } else {
        this.isShowTable = true;
      }
    },
    downloadDom() {
      let imgname = "Aging_Trend.png"
      let widgetID = "agingtrendsnap"
      this.isHovered = false
      var geticondiv = document.querySelectorAll('#agingtrendsnap .insideL,#agingtrendsnap .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
    downIns() {
      let fileName = 'AgingTrend_Insights.txt'
      let insArr = []
      insArr = this.aginginsight.join("\r\n")
      var fileToSave = new Blob([insArr], {
        type: 'application/json',
        name: fileName
      });
      saveAs(fileToSave, fileName)
    },
    setAgingData(agingset, splitLabel) {
      var splitperc = []
      this.splitlabel = []
      var splitarray = new Array()
      for (var i = 0; i < splitLabel.length; i++) {
        splitarray = splitLabel[i].split('|')
        this.splitlabel.push(splitarray[0] + "hr")
        splitperc.push(splitarray[1])
      }
      this.dispTable = [];
      let elemT = JSON.parse(JSON.stringify(this.splitlabel));
      elemT.splice(0, 0, 'Aging Bucket');
      this.dispTable.push(elemT);
      this.seriesArr = []
      for (let index = 0; index < agingset.length; index++) {
        elemT = JSON.parse(JSON.stringify(agingset[index].Bardata));
        elemT.splice(0, 0, agingset[index].label);
        this.dispTable.push(elemT);
        this.seriesArr.push({
          name: agingset[index].label,
          type: 'bar',
          data: agingset[index].Bardata,
          animationDurationUpdate: 1000,
          universalTransition: true,
          itemStyle: {
            color: this.myColorArray[index % 11],
            borderRadius: 2,
            borderColor: this.myBorderArray[index % 11],
            borderWidth: 1,
          }
        })
      }
      this.dispTable = this.dispTable[0].map((col, i) => this.dispTable.map(row => row[i]));
      this.asgLis = [];
      for (let index = 1; index < this.dispTable.length; index++) {
        const element = this.dispTable[index];
        var elemT3 = {};
        var countOverall = 0;
        for (let index1 = 0; index1 < element.length; index1++) {
          const element1 = element[index1];
          let varT = this.dispTable[0][index1].toString()
          if (index1 != 0) {
            countOverall += element1;
          }
          elemT3[varT] = element1
        }
        elemT3["Overall"] = countOverall
        this.asgLis.push(elemT3);
      }
      this.val1 = (this.asgLis[0].Overall + this.asgLis[1].Overall + this.asgLis[2].Overall + this
        .asgLis[3].Overall);
      this.val2 = (this.asgLis[4].Overall + this.asgLis[5].Overall + this.asgLis[6].Overall);
      this.val3 = (this.asgLis[7].Overall);
      this.val4 = (this.asgLis[8].Overall);
      this.perc1 = (this.val1 / this.$parent.FilterTic_Count * 100).toFixed(1);
      this.perc2 = (this.val2 / this.$parent.FilterTic_Count * 100).toFixed(1);
      this.perc3 = (this.val3 / this.$parent.FilterTic_Count * 100).toFixed(1);
      this.perc4 = (this.val4 / this.$parent.FilterTic_Count * 100).toFixed(1);
      var keyCount = 0
      var keyVal = Object.keys(this.asgLis[0])
      let elemT2;
      for (let key in this.asgLis[0]) {
        if (key == "Aging Bucket") {
          elemT2 = {
            headerName: 'Aging Bucket',
            field: 'Aging Bucket',
            sortable: true,
          };
        } else {
          elemT2 = {
            headerName: keyVal[keyCount],
            field: keyVal[keyCount],
            sortable: true,
          };
        }
        this.asgcolsDefs.push(elemT2)
        // increase the count
        keyCount++;
      }
      this.drawAging()
    },
    swapCharts() {
      this.isdrawBar = !this.isdrawBar;
      this.drawAging()
    },
    drawAging() {
      var emit = this.$emit
      if (this.isdrawBar) {
        for (let index = 0; index < this.seriesArr.length; index++) {
          const element = this.seriesArr[index];
          element.type = 'bar'
        }
      } else {
        for (let index = 0; index < this.seriesArr.length; index++) {
          const element = this.seriesArr[index];
          element.type = 'line'
          element.areaStyle = {
            color: this.myBorderArray[index % 11],
            opacity: 0.05
          }
        }
      }
      chartDomAge = document.getElementById('agingtrend');
      if(chartDomAge == null) return;
      if (chartDomAge != null && chartDomAge != undefined) {
        chartDomAge.style.height = "300px"
        chartDomAge.style.width = (document.getElementById('agingtrendsnap').clientWidth - 50) + "px";
        if (this.isChartRedraw) {
          this.isChartRedraw = false;
          myChartAge = echarts.init(chartDomAge);
        }
        let optionAge = {
          toolbox: {
            right: 20,
            itemSize: 20,
            iconStyle: {
              borderColor: '#777'
            },
            feature: {
              magicType: {
                type: ['stack']
              }
            }
          },
          tooltip: {
            confine: true,
            trigger: 'axis',
          },
          legend: {
            textStyle: {
              color: "#52aab2"
            },
            type: 'scroll'
          },
          grid: {
            left: 0,
            top: 30,
            right: '3%',
            bottom: 20,
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            data: this.splitlabel,
            interval: 0,
            axisLabel: {
              fontSize: 10,
              color: "#777"
            },
          }],
          yAxis: [{
            type: 'value',
            splitLine: {
              show: false
            },
            axisLine: {
              show: true
            },
            axisLabel: {
              fontSize: 10,
              color: "#777"
            },
          }],
          series: this.seriesArr
        };
        myChartAge.setOption(optionAge, {
          notMerge: true
        });
        myChartAge.on('click', function (params) {
          if (params.componentType === 'series' && params.data != undefined) {
            let clickitem = {
              "currpass": params.seriesName + "~" + params.name,
              "filterop": "Aging"
            }
            emit("getKDrill", clickitem)
          }
        })
      }
    },
    getAginginsights(cond) {
      this.IsAgeErr = false
      this.IsAgeshow = false
      this.IsAgInsErr = false
      this.isLoadAgn = false
      this.axios.post(this.uriApiUrl + 'DataAnalysis/agingtrendviews?asg_id=' + this.asgId + "&Cond=" + cond, {
        "get_prior": this.getPins.get_prior,
        "selid": this.getPins.selid,
        "edited": this.getPins.edited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Nodata") {
              this.IsAgeshow = true
              this.agingwholedata = response.data
              this.aginginsight = this.agingwholedata.insights
              var agingset = this.agingwholedata.Agingtrend
              if (this.aginginsight.length == 0) {
                this.IsAgInsErr = true
              }
              if (this.isChartRedraw) {
                try {
                  echarts.dispose(myChartAge);
                } catch (error) {
                  console.log("..")
                }
              }
              this.setAgingData(agingset, this.agingwholedata.Labels)
            } else if (response.data == "Nodata") {
              this.IsInsightAging = true
            } else {
              this.IsAgeErr = true
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in Aging Trend. Try after sometime!'
              })
            }
          }
          this.isLoadAgn = true
        }).catch((response) => {
          this.IsAgeErr = true
          this.isLoadAgn = true
          if (this.enabledDebug == 1) {
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in Aging Trend. Try after sometime!'
            })
          }
        })
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.isChartRedraw = true
    this.myColorArray = [new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(253, 55, 56, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(253, 55, 56, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(247, 99, 12, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(247, 99, 12, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(255, 185, 0, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(255, 185, 0, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(75, 192, 192, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(75, 192, 192, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(54, 162, 235, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(54, 162, 235, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(136,23,152, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(136,23,152, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(168, 192, 255, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(168, 192, 255, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(255, 216, 155, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(255, 216, 155, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(178, 159, 148, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(178, 159, 148, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(54, 191, 54, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(54, 191, 54, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(75, 19, 79, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(75, 19, 79, 0.4)'
    }]),
    ]
    this.myBorderArray = ['rgba(253, 55, 56, 0.9)',
      'rgba(247, 99, 12, 0.9)',
      'rgba(255, 185, 0, 0.9)',
      'rgba(75, 192, 192, 0.9)',
      'rgba(54, 162, 235, 0.9)',
      'rgba(136,23,152, 0.9)',
      'rgba(168, 192, 255,0.9)',
      'rgba(255, 216, 155,0.9)',
      'rgba(178, 159, 148, 0.9)',
      'rgba(54, 191,54,0.9)',
      'rgba(75, 19, 79, 1.0)'
    ]
    this.getAginginsights(this.getwgtCond)
    window.addEventListener("resize", reportWindowSizeAge);
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeAge);
  },
  computed: {
    getwgtCond() {
      return this.$store.state.widgetCond
    },
    getgradGreen() {
      return this.$store.getters.getgradGreen
    },
    getgradRed() {
      return this.$store.getters.getgradRed
    },
    getgradOrange() {
      return this.$store.getters.getgradOrange
    },
    getgradYellow() {
      return this.$store.getters.getgradYellow
    },
    getgradCyan() {
      return this.$store.getters.getgradCyan
    },
    getgradBlue() {
      return this.$store.getters.getgradBlue
    },
    getgradPurple() {
      return this.$store.getters.getgradPurple
    },
    getgradOceanBlue() {
      return this.$store.getters.getgradOceanBlue
    },
    getgradSandal() {
      return this.$store.getters.getgradSandal
    },
    getgradBrown() {
      return this.$store.getters.getgradBrown
    },
    getgradViolet() {
      return this.$store.getters.getgradViolet
    },
  },
  watch: {
    getPins() {
      this.getAginginsights(this.getwgtCond)
    },
    getpass() {
      this.getAginginsights(this.getwgtCond)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>